// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/authStore";

// Private
import Profile from "@/views/profile/index";

// Public
import Home from "@/views/home/index";
import Bible from "@/views/bible/index";
import Videos from "@/views/videos/index";

import Login from "@/views/auth/login";
import Register from "@/views/auth/register";
import NotFound from "@/views/notFound";
import NotAuthorized from "@/views/notAuthorized";

// Layout
import PublicLayout from "@/layouts/publicLayout";
import PrivateLayout from "@/layouts/privateLayout";
import Maintenance from "@/views/maintenance.vue";

const isMaintenance = process.env.VUE_APP_MAINTENANCE_MODE === "true";

const routes = isMaintenance ? [
  {
    path: "/:catchAll(.*)",
    name: "Maintenance",
    component: Maintenance,
  },
] : [
  {
    path: "/",
    component: PublicLayout,
    children: [
      {
        path: "/",
        name: "home",
        component: Home
      },
      {
        path: "/biblia",
        name: "bible",
        component: Bible
      },
      {
        path: "/videos",
        name: "videos",
        component: Videos,
      },
      {
        path: "/login",
        name: "login",
        component: Login,
      },
      {
        path: "/register",
        name: "register",
        component: Register,
      },      
      {
        path: "/401",
        name: "notAuthorized",
        component: NotAuthorized,
      },
      { path: "/:pathMatch(.*)*", name: "notFound", component: NotFound },
    ],
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/",
    component: PrivateLayout,
    children: [
      {
        path: "/perfil",
        name: "profile",
        component: Profile,
      },
    ]
  },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.matched.some((x) => x.meta.requireAuth);
  const roles = to.meta.roles;

  // Verificar se o usuário está autenticado
  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: "login" });
    return;
  }

  // Verificação de papel (roles)
  if (roles) {
    const userRoles = authStore.user?.roles || [];
    const authorized = roles.some((role) => userRoles.includes(role));

    if (!authorized) {
      next({ name: "notAuthorized" });
      return;
    }
  }

  // Verificar a expiração do token
  const expiresAt = localStorage.getItem("expiresAt");
  if (expiresAt && new Date().getTime() > expiresAt) {
    authStore.logout(); // Realiza o logout
    next({ name: "login" }); // Redireciona para login
    return;
  }

  next(); // Continuar a navegação
});
export default router;
